<script setup lang="ts">
export interface BoxProps {
    padding?: string
    class?: string
    size: number
}

const props = withDefaults(defineProps<BoxProps>(), {
    class: '',
    padding: 'p-3',
})
</script>
<template>
  <div
    class="rounded-circle icon-rounded-wrapper d-flex align-items-center justify-content-center"
    :style="`--icon-rounde-wrapper-size: ${props.size}px`"
    :class="`${props.class} ${props.padding}`"
  >
    <slot />
  </div>
</template>
<style scoped>
@import './IconRoundedWrapper.scss';
</style>
